import React, { useEffect, useState } from "react";
import SectionLayout from "../reusable/SectionLayout";
import CreditLimitCard from "./CreditLineCard";
import fetchFarmerCreditDetails from "../../apis/fetchFarmerCreditDetails";
import fetchFarmerRepaymentTransactionDetails from "../../apis/fetchFarmerRepaymentTransactionDetails";
import { CreditResponse, FarmerCreditResponse } from "../../models/credit";
import ToastAndroid from "app/mocks/ToastAndroid";

interface Props {
  highlight: boolean;
  farmerId: string;
  name: string;
}

const CreditSection = ({ highlight, farmerId, name }: Props) => {
  const [loading, setLoading] = useState(true);
  const [farmerCreditDetails, setFarmerCreditDetails] =
    useState<FarmerCreditResponse | null>(null);
  const [creditDetails, setCreditDetails] = useState<CreditResponse | null>(
    null,
  );

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [data, repaymentData] = await Promise.all([
          fetchFarmerCreditDetails(farmerId),
          fetchFarmerRepaymentTransactionDetails(farmerId),
        ]);
        if (data) setCreditDetails(data);
        if (repaymentData) setFarmerCreditDetails(repaymentData);
      } catch {
        ToastAndroid.show(
          "Failed to load credit details. Please try again.",
          ToastAndroid.SHORT,
        );
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [farmerId]);

  return (
    <SectionLayout
      loading={loading}
      title="Credit Lines"
      description={"Lender Credit: Yes"}
      highlight={highlight}
    >
      <CreditLimitCard
        creditDetails={creditDetails}
        farmerId={farmerId}
        farmerName={name}
        farmerCreditDetails={farmerCreditDetails}
      />
    </SectionLayout>
  );
};

export default CreditSection;
